import { render, staticRenderFns } from "./UnauthorizedReachData.vue?vue&type=template&id=535c60de&scoped=true"
import script from "./UnauthorizedReachData.vue?vue&type=script&lang=js"
export * from "./UnauthorizedReachData.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedReachData.vue?vue&type=style&index=0&id=535c60de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c60de",
  null
  
)

export default component.exports